import React from 'react';
export function WordmarkOptions() {
  return <div className="min-h-screen bg-slate-50 py-16 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-895">
      <div className="max-w-7xl mx-auto" data-id="element-896">
        <div className="text-center mb-16" data-id="element-897">
          <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight mb-4" data-id="element-898">
            Wordmark Explorations
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-899">
            12 typography-focused logo variations inspired by the Bold Wordmark
            concept. Exploring weight, spacing, case, and subtle accents.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-900">
          {/* 1. The Original Inspiration */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-901">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-902">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-903">
                1. The Original
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-904">
                Black / Tighter / Gradient AI
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-905">
              <div className="flex items-baseline" data-id="element-906">
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-907">
                  SWEDENMARK
                </span>
                <span className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500 ml-1" data-id="element-908">
                  AI
                </span>
                <div className="w-2 h-2 rounded-full bg-emerald-500 ml-1 mb-1" data-id="element-909"></div>
              </div>
            </div>
          </div>

          {/* 2. Minimalist Wide */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-910">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-911">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-912">
                2. Minimalist Wide
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-913">
                Light / Widest / Bold AI
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-914">
              <div className="flex items-center" data-id="element-915">
                <span className="text-xl font-light text-slate-800 tracking-[0.3em] uppercase" data-id="element-916">
                  Swedenmark
                </span>
                <span className="text-xl font-bold text-blue-600 ml-2" data-id="element-917">AI</span>
              </div>
            </div>
          </div>

          {/* 3. Lowercase Tech */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-918">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-919">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-920">
                3. Lowercase Tech
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-921">
                Lowercase / Tight / Colored Dot
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-922">
              <div className="flex items-baseline" data-id="element-923">
                <span className="text-3xl font-bold text-slate-800 tracking-tight" data-id="element-924">
                  swedenmark
                </span>
                <span className="text-3xl font-light text-slate-400 ml-1" data-id="element-925">
                  ai
                </span>
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 ml-1" data-id="element-926"></div>
              </div>
            </div>
          </div>

          {/* 4. The Pill Badge */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-927">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-928">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-929">
                4. The Pill Badge
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-930">
                Bold / Badge Accent
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-931">
              <div className="flex items-center" data-id="element-932">
                <span className="text-2xl font-extrabold text-slate-900 tracking-tight uppercase" data-id="element-933">
                  Swedenmark
                </span>
                <span className="ml-2 px-2 py-0.5 bg-blue-600 text-white text-sm font-bold rounded-full tracking-wider" data-id="element-934">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 5. Two-Tone Split */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-935">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-936">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-937">
                5. Two-Tone Split
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-938">
                Bold + Light / Monochromatic
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-939">
              <div className="flex items-center" data-id="element-940">
                <span className="text-3xl font-black text-[#0f2546] tracking-tighter uppercase" data-id="element-941">
                  SWEDEN
                </span>
                <span className="text-3xl font-light text-[#0f2546] tracking-tighter uppercase" data-id="element-942">
                  MARK
                </span>
                <span className="text-3xl font-bold text-blue-500 ml-1.5" data-id="element-943">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 6. Superscript */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-944">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-945">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-946">
                6. Superscript
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-947">
                Heavy / Elevated Accent
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-948">
              <div className="flex items-start" data-id="element-949">
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight uppercase" data-id="element-950">
                  SWEDENMARK
                </span>
                <span className="text-sm font-black text-purple-600 ml-0.5 mt-1" data-id="element-951">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 7. Tech Stacked */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-952">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-953">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-954">
                7. Tech Stacked
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-955">
                Stacked / High Contrast
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-956">
              <div className="flex flex-col items-start leading-none" data-id="element-957">
                <span className="text-sm font-bold text-slate-500 tracking-[0.3em] uppercase mb-1" data-id="element-958">
                  Swedenmark
                </span>
                <span className="text-4xl font-black text-blue-600 tracking-tighter" data-id="element-959">
                  AI Systems
                </span>
              </div>
            </div>
          </div>

          {/* 8. The Underline */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-960">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-961">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-962">
                8. The Underline
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-963">
                Clean / Structural
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-964">
              <div className="relative inline-block" data-id="element-965">
                <div className="flex items-baseline pb-1" data-id="element-966">
                  <span className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-967">
                    Swedenmark
                  </span>
                  <span className="text-2xl font-bold text-slate-400 ml-1.5" data-id="element-968">
                    AI
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-purple-500" data-id="element-969"></div>
              </div>
            </div>
          </div>

          {/* 9. Continuous Sweep */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-970">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-971">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-972">
                9. Continuous Sweep
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-973">
                Full Gradient / Tight
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-slate-900" data-id="element-974">
              <span className="text-3xl font-black tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400" data-id="element-975">
                SWEDENMARK AI
              </span>
            </div>
          </div>

          {/* 10. Monospace Vibe */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-976">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-977">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-978">
                10. Monospace Vibe
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-979">
                Technical / Code-like
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-980">
              <div className="flex items-center font-mono" data-id="element-981">
                <span className="text-lg font-bold text-slate-800 tracking-tight" data-id="element-982">
                  swedenmark
                </span>
                <span className="text-lg font-bold text-emerald-500" data-id="element-983">_ai</span>
              </div>
            </div>
          </div>

          {/* 11. Editorial Serif-Style */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-984">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-985">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-986">
                11. Editorial
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-987">
                Classic / Refined
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-[#faf8f5]" data-id="element-988">
              <div className="flex items-baseline" data-id="element-989">
                <span className="text-2xl font-medium text-[#2c2418] tracking-widest uppercase" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-990">
                  Swedenmark
                </span>
                <span className="text-sm font-bold text-amber-600 ml-2 tracking-widest" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-991">
                  A.I.
                </span>
              </div>
            </div>
          </div>

          {/* 12. Dark Mode Glow */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-992">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-993">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-994">
                12. Dark Mode Glow
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-995">
                High Contrast / Neon
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-[#0f1729] relative overflow-hidden" data-id="element-996">
              <div className="absolute w-32 h-32 bg-blue-500/20 rounded-full blur-2xl top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-997"></div>
              <div className="flex items-center relative z-10" data-id="element-998">
                <span className="text-2xl font-bold text-white tracking-tight" data-id="element-999">
                  Swedenmark
                </span>
                <span className="text-2xl font-black text-blue-400 ml-1 drop-shadow-[0_0_8px_rgba(96,165,250,0.8)]" data-id="element-1000">
                  AI
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}